<template>
  <v-list dense>
    <v-list-group prepend-icon="fa-cog">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Options du compte</v-list-item-title>
        </v-list-item-content>
      </template>

      <v-list-item dense link class="small-list">
        <UserBillingEditor></UserBillingEditor>
      </v-list-item>
      <v-list-item dense link class="small-list">
        <UserPasswordEditor></UserPasswordEditor>
      </v-list-item>
      <v-list-item dense link class="small-list">
        <UserAdminPasswordEditor></UserAdminPasswordEditor>
      </v-list-item>
      <v-list-item dense link class="small-list">
        <UserStoreKeyEditor></UserStoreKeyEditor>
      </v-list-item>
      <v-list-item
        dense
        link
        class="small-list"
        @click="openCustomerPortal"
        v-show="getCustomerId !== undefined && getCustomerId !== null"
      >
        <v-list-item-content>
          <v-list-item-subtitle>Abonnement</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item dense link class="small-list">
        <UserStoreInventorySettings></UserStoreInventorySettings>
      </v-list-item> -->
    </v-list-group>
  </v-list>
</template>

<script>
import UserPasswordEditor from "./UserPasswordEditor";
import UserAdminPasswordEditor from "./UserAdminPasswordEditor";
import UserStoreKeyEditor from "./UserStoreKeyEditor";
import UserBillingEditor from "./UserBillingEditor";
import { api } from "@/api";
import { mapGetters } from "vuex";
// import UserStoreInventorySettings from "./UserStoreInventorySettings";
export default {
  name: "UserSettingsEditor",
  components: {
    UserPasswordEditor,
    UserAdminPasswordEditor,
    UserStoreKeyEditor,
    UserBillingEditor
    // UserStoreInventorySettings
  },
  computed: {
    ...mapGetters(["getCustomerId"])
  },
  methods: {
    async openCustomerPortal() {
      const res = await api.getCustomerPortal();
      if (res) {
        const portal = window.open(res.url, "_blank");
        portal.focus();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.small-list {
  padding-left: 20px !important;
}
</style>
